/**
 * Billing Success Page
 *
 * Where Stripe sends users after a successful subscription payment.
 * The webhook that unlocks the account can take a second or two, so we poll the
 * status a few times before showing the final confirmation.
 */

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { billingApi } from '../services/api'
import { useAuth } from '../context/AuthContext'

const NAVY = '#0A1F44'
const BLUE = '#1E5BD6'

export default function BillingSuccess() {
  const [state, setState] = useState('checking') // checking | active | pending
  const { refreshPlan } = useAuth()

  useEffect(() => {
    let cancelled = false
    let attempts = 0

    const check = async () => {
      attempts += 1
      try {
        const { data } = await billingApi.getStatus()
        if (cancelled) return
        if (data.active) {
          setState('active')
          // Update the plan everywhere the app reads it (useAuth()), not just
          // this page's local state — otherwise the newly-unlocked tools
          // stay hidden until the next full page reload.
          refreshPlan()
          return
        }
      } catch {
        // ignore and retry
      }
      if (attempts >= 5) {
        if (!cancelled) setState('pending')
        return
      }
      setTimeout(check, 2000)
    }

    check()
    return () => { cancelled = true }
  }, [])

  return (
    <div style={{ maxWidth: 520, margin: '80px auto', textAlign: 'center', padding: 24 }}>
      <h1 style={{ color: NAVY, fontSize: 28, marginBottom: 12 }}>
        {state === 'active' ? "🎉 You're all set!" : 'Thanks for subscribing!'}
      </h1>
      <p style={{ color: '#445', fontSize: 16, lineHeight: 1.5 }}>
        {state === 'active'
          ? 'Your JAI subscription is active. Your JAI credits for the month are ready to use.'
          : state === 'pending'
            ? "Your payment went through — your account will unlock in a moment. If it doesn't, refresh this page shortly."
            : 'Confirming your payment…'}
      </p>
      <Link
        to="/chat"
        style={{
          display: 'inline-block', marginTop: 24, background: BLUE, color: '#fff',
          textDecoration: 'none', borderRadius: 10, padding: '12px 22px', fontWeight: 600,
        }}
      >
        Go to JAI
      </Link>
    </div>
  )
}
